import { useEffect, useState } from 'react';
import { isArray } from 'lodash-es';
import useTranslation from 'next-translate/useTranslation';
import Select from 'react-select';
import { useAppDispatch, useAppSelector } from '@/app/hooks';
import { setManufacturers } from './productsFilterSlice';
import { AppState } from '@/app/store';
import { Manufacturer } from '@/lib/types/bevmaq.types';
import useManufacturers from '@/lib/hooks/fetchers/useManufacturers';

function isManufacturerArray(anyObj: any): anyObj is Manufacturer[] {
  return (
    isArray(anyObj) &&
    anyObj.every((c) => 'id' in c && 'name' in c && Object.keys(c).length === 2)
  );
}
/* eslint-disable no-unused-vars */
export default function ManufacturerFilter({
  returnKey = 'name',
}: {
  returnKey: keyof Manufacturer;
}) {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const manufacturers = useAppSelector(
    (state: AppState) => state.productFilter.manufacturers
  );
  const { manufacturersOptions } = useManufacturers();
  const [selections, setSelections] = useState<Manufacturer[]>([]);

  function handleSetManufacturers(selectedManufacturers: any) {
    if (isManufacturerArray(selectedManufacturers)) {
      setSelections(selectedManufacturers);
      dispatch(
        setManufacturers(selectedManufacturers.map((c) => c[returnKey]))
      );
    }
  }
  useEffect(() => {
    setSelections(
      manufacturersOptions.filter(
        (c: Manufacturer) => manufacturers && manufacturers?.includes(c.name)
      )
    );
  }, [manufacturers, manufacturersOptions]);
  return (
    <div className=''>
      <h3 className='my-6 text-sm font-medium text-gray-900'>
        {t('common:Manufacturers')}
      </h3>
      <Select
        value={selections}
        options={manufacturersOptions}
        isMulti
        styles={{
          input: (base) => ({
            ...base,
            'input:focus': {
              boxShadow: 'none',
            },
          }),
        }}
        getOptionLabel={(c: Manufacturer) => c.name}
        getOptionValue={(c: Manufacturer) => c.id}
        placeholder=''
        onChange={handleSetManufacturers}
        noOptionsMessage={() => t('common:no options')}
      />
    </div>
  );
}
